import SettingsLayout from "./SettingsLayout";

export default function Settings() {
    return (
        <SettingsLayout>
            <div />
        </SettingsLayout>
    );
}